/**
 * Created by yiren on 2019-08-29
 * Loading
 */

import React from 'react';
import style from './style.css'

export default class Loading extends React.Component {
    render() {
        return (
            <div className={style.box}>
                <div className={style["loader-02"]}></div>
            </div>
        );
    }
}